import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Flex, Text } from '@chakra-ui/react';
import { useAuth } from '@/contexts/AuthContext';
import { LoginForm } from './components/LoginForm/LoginForm';
import { SuccessAnimation } from './components/SuccessAnimation/SuccessAnimation';
import { getPostAuthRedirectOrDefault } from '@/utils/postAuthRedirect';

export const LoginPage = () => {
  const navigate = useNavigate();
  const { loading: authLoading, user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false);
  const [formOpacity, setFormOpacity] = useState(1);
  const [formScale, setFormScale] = useState(1);

  useEffect(() => {
    if (!authLoading && user) {
      navigate(getPostAuthRedirectOrDefault(), { replace: true });
    }
  }, [authLoading, user, navigate]);

  const animateSuccess = () => {
    setFormOpacity(0);
    setFormScale(0.95);

    setTimeout(() => {
      setLoginSuccess(true);
    }, 300);

    setTimeout(() => {
      if ('vibrate' in navigator) {
        navigator.vibrate(50);
      }
      navigate(getPostAuthRedirectOrDefault(), { replace: true });
    }, 2000);
  };

  if (authLoading) {
    return (
      <Flex position="fixed" inset="0" overflow="hidden" bgGradient="to-b" gradientFrom="gray.50" gradientTo="white" justify="center" align="center" p="5">
        <Text fontSize="lg" fontWeight="medium" color="volyx.primary">Loading...</Text>
      </Flex>
    );
  }

  return (
    <>
      <Flex
        position="fixed"
        inset="0"
        overflow="hidden"
        bgGradient="to-b"
        gradientFrom="gray.50"
        gradientTo="white"
        justify="center"
        align={{ base: 'stretch', md: 'center' }}
        px={{ base: '0', md: '4' }}
        pt={{ base: 'env(safe-area-inset-top, 0px)', md: '3rem' }}
        pb={{ base: '0', md: '3rem' }}
        onClick={(e) => e.stopPropagation()}
      >
        <Box
          w="full"
          maxW={{ base: 'full', md: '440px' }}
          h={{ base: '100%', md: 'auto' }}
          maxH="100%"
          overflowY="auto"
          display="flex"
          flexDirection="column"
          borderRadius={{ base: '0', md: 'xl' }}
          border={{ base: 'none', md: '1px solid' }}
          borderColor="volyx.borderLight"
          bg="white"
          boxShadow={{ base: 'none', md: 'lg' }}
          style={{
            opacity: formOpacity,
            transform: `scale(${formScale})`,
            transition: 'opacity 0.3s ease, transform 0.3s ease',
          }}
        >
          <LoginForm
            onLoginSuccess={animateSuccess}
            loading={loading}
            setLoading={setLoading}
          />
        </Box>
      </Flex>

      <SuccessAnimation visible={loginSuccess} />
    </>
  );
};
